import {
    GraphqlErrorLike,
    GraphqlExceptionLike,
    MutationResultLike,
} from '../types';

export const extractErrorMessage = (
    error: GraphqlExceptionLike | GraphqlErrorLike | string | null | undefined,
    defaultMessage: string
): string => {
    try {
        let message = '';

        if (typeof error === 'string') {
            message = error;
        }

        if (!message && error instanceof Error) {
            if (
                'graphQLErrors' in error &&
                Array.isArray(error.graphQLErrors) &&
                error.graphQLErrors.length > 0
            ) {
                message = error.graphQLErrors[0]?.message || '';
            } else if (error.message) {
                message = error.message;
            }
        }

        if (
            !message &&
            error &&
            typeof error === 'object' &&
            'message' in error
        ) {
            message = String(error.message || '');
        }

        if (!message && error) {
            const str = String(error);
            if (str && str !== '[object Object]') {
                message = str;
            }
        }

        if (message) {
            message = message.replace(/^INTERNAL_SERVER_ERROR::\s*/, '');

            if (message.includes('Document failed validation')) {
                return 'Unable to save the scope. Please check the values and try again.';
            }
            if (message.includes('already exists')) {
                return 'This scope already exists. Please choose a different scope.';
            }

            if (message.length > 0) {
                return message;
            }
        }
    } catch {
        // fall through to default message
    }

    return defaultMessage;
};

export const getMutationError = (result: MutationResultLike): string | null => {
    if (
        result?.errors &&
        Array.isArray(result.errors) &&
        result.errors.length > 0
    ) {
        return result.errors[0]?.message || null;
    }

    if (
        result.data &&
        typeof result.data === 'object' &&
        'errors' in result.data
    ) {
        const errors = result.data.errors;
        if (Array.isArray(errors) && errors.length > 0) {
            const firstError = errors[0];
            return firstError &&
                typeof firstError === 'object' &&
                'message' in firstError
                ? String(firstError.message || '') || null
                : null;
        }
    }

    return null;
};
